// src/components/sdk/components/UsageStats.tsx
import React from 'react';
import { Card, Typography } from 'antd';
import i18n from '../../../i18n';
// import i18n from '../../i18n';

const { Text } = Typography;

interface UsageStatsProps {
    t: (key: string) => string;
    usageTotal: number;
    usageTotalUsage: number;
    usagePage: number;
    usageTotalPages: number;
    isMobile?: boolean;
}

export const UsageStats: React.FC<UsageStatsProps> = ({
    t,
    usageTotal,
    usageTotalUsage,
    usagePage,
    usageTotalPages,
    isMobile = false,
}) => {
    // 获取当前语言
    const currentLang = i18n.language || 'zh_CN';
    const isEnglish = currentLang === 'en_US' || currentLang === 'en';

    const stats = [
        {
            label: t('sdk.usage.totalRecords') || '总记录数',
            value: usageTotal,
            color: '#1890ff',
        },
        {
            label: t('sdk.usage.totalUsage') || '总使用次数',
            value: usageTotalUsage,
            color: '#52c41a',
        },
        {
            label: t('sdk.usage.currentPage') || '当前页',
            value: `${usagePage} / ${usageTotalPages}`,
            color: '#faad14',
        },
    ];

    // 根据设备和语言决定字体大小
    const getLabelFontSize = () => {
        if (isMobile) {
            return isEnglish ? 12 : 18;
        }
        return isEnglish ? 12 : 14;
    };

    const getValueFontSize = () => {
        if (isMobile) {
            return isEnglish ? 14 : 18;
        }
        return isEnglish ? 18 : 24;
    };

    return (
        <div style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: isMobile ? 6 : 16,
            marginBottom: 16,
        }}>
            {stats.map((stat, index) => (
                <Card
                    key={index}
                    size="small"
                    style={{
                        textAlign: 'center',
                        borderRadius: 8,
                    }}
                    bodyStyle={{ padding: isMobile ? '4px 4px' : '16px 20px' }}
                >
                    <Text type="secondary" style={{ fontSize: getLabelFontSize() }}>
                        {stat.label}
                    </Text>
                    <div style={{
                        fontSize: getValueFontSize(),
                        fontWeight: 'bold',
                        color: stat.color,
                        marginTop: 2,
                    }}>
                        {stat.value}
                    </div>
                </Card>
            ))}
        </div>
    );
};